import React from 'react';

export default function SoloConnectMobileFooter() {
  return (
    <footer className="bg-[#7209B7] text-white">
      {/* Main Content */}
      <div className="px-6 pt-10 pb-6">

        {/* Logo Text - Centered */}
        <div className="text-center mb-4">
          <span className="text-3xl font-extrabold tracking-tight">
            <span className="text-white">Solo</span><span className="text-white">Connect</span><span className="text-white">.</span>
          </span>
        </div>

        {/* Description - Centered */}
        <p className="text-sm text-white/85 leading-relaxed text-center mb-6">
          SoloConnect helps solo travelers find like minded companions, explore new places, and create unforgettable memories together.
        </p>

        {/* CTA Button - Centered */}
        <div className="flex justify-center mb-8">
          {/* <button className="flex items-center gap-3 border border-white rounded-full px-5 py-3 text-sm font-semibold hover:bg-white hover:text-[#7209B7] transition-all duration-200">
            <span className="w-8 h-8 bg-[#7209B7] border border-white rounded-full flex items-center justify-center flex-shrink-0">
              <svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 24 24">
                <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z" />
              </svg>
            </span>
            Let's travel together, even if solo.
          </button> */}
        </div>

        {/* Quick Links + Support - 2 Column Grid */}
        <div className="grid grid-cols-2 gap-6 mb-8">
          {/* Quick Links */}
          <div>
            <h4 className="text-base font-bold mb-3 pb-2 border-b border-white/30">Quick Links</h4>
            <ul className="space-y-2.5">
              <li>
                <a href="/privacypolicy" className="text-sm text-white/85 hover:text-white transition-colors flex items-center gap-1">
                  <span className="text-white/60">&gt;</span> Privacy Policy
                </a>
              </li>
              <li>
                <a href="/termsandconditions" className="text-sm text-white/85 hover:text-white transition-colors flex items-center gap-1">
                  <span className="text-white/60">&gt;</span> Terms & Conditions
                </a>
              </li>
              <li>
                <a href="/community-guidelines" className="text-sm text-white/85 hover:text-white transition-colors flex items-center gap-1">
                  <span className="text-white/60">&gt;</span> Community Guidelines
                </a>
              </li>
              <li>
                <a href="/contactus" className="text-sm text-white/85 hover:text-white transition-colors flex items-center gap-1">
                  <span className="text-white/60">&gt;</span> Contact Us
                </a>
              </li>
              <li>
                <a href="/faq" className="text-sm text-white/85 hover:text-white transition-colors flex items-center gap-1">
                  <span className="text-white/60">&gt;</span> FAQs
                </a>
              </li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h4 className="text-base font-bold mb-3 pb-2 border-b border-white/30">Support</h4>
            <ul className="space-y-2.5">
              <li>
                <a href="/help-center" className="text-sm text-white/85 hover:text-white transition-colors flex items-center gap-1">
                  <span className="text-white/60">&gt;</span> Help Center
                </a>
              </li>
              <li>
                <a href="/safety-tips" className="text-sm text-white/85 hover:text-white transition-colors flex items-center gap-1">
                  <span className="text-white/60">&gt;</span> Safety Tips
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Connect with us - Centered */}
        <div className="text-center mb-6">
          <h4 className="text-base font-bold mb-2">Connect with us</h4>
          {/* Underline */}
          <div className="w-12 h-0.5 bg-white mx-auto mb-5"></div>

          <div className="flex items-center justify-center gap-4">
            {/* Instagram */}
            <a
              href="https://www.instagram.com/joinsoloconnect/"
              target="_blank"
              rel="noopener noreferrer"
              className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center hover:bg-white hover:text-[#7209B7] transition-all duration-200"
            >
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
              </svg>
            </a>

            {/* Facebook */}
            <a
              href="https://www.facebook.com/profile.php?id=61585472053103"
              target="_blank"
              rel="noopener noreferrer"
              className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center hover:bg-white hover:text-[#7209B7] transition-all duration-200"
            >
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
              </svg>
            </a>

            {/* YouTube */}
            <a
              href="https://youtube.com/@soloconnect-travel?si=n-hGlcXmc32ZZUI-"
              target="_blank"
              rel="noopener noreferrer"
              className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center hover:bg-white hover:text-[#7209B7] transition-all duration-200"
            >
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
              </svg>
            </a>

            {/* WhatsApp */}
            <a
              href="https://wa.me/919311146657"
              target="_blank"
              rel="noopener noreferrer"
              className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center hover:bg-white hover:text-[#7209B7] transition-all duration-200"
            >
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.570-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.465 3.488" />
              </svg>
            </a>
          </div>
        </div>

        {/* Divider */}
        <div className="w-full h-px bg-white/25 mb-5"></div>

        {/* Bottom Section */}
        <div className="flex items-center justify-center gap-2 mb-2">
          <svg className="w-4 h-4 text-white/80 flex-shrink-0" fill="currentColor" viewBox="0 0 24 24">
            <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 4l6 2.67V11c0 3.96-2.67 7.64-6 8.87-3.33-1.23-6-4.91-6-8.87V7.67L12 5z" />
          </svg>
          <span className="text-sm text-white/80">© 2025 All Rights Reserved</span>
        </div>

        <div className="text-center text-sm text-white/80">
          Powered by{' '}
          <a
            href="https://www.datametricks.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="font-bold text-white hover:underline"
          >
            DataMetricks Consulting Pvt. Ltd.
          </a>
        </div>
      </div>
    </footer>
  );
}